export const LEVELS = ["1 Star", "2 Star", "3 Star", "4 Star", "5 Star", "PRIME"];
export const BANDS = { "1 Star": "0.0–9.9%", "2 Star": "10.0–24.9%", "3 Star": "25.0–39.9%", "4 Star": "40.0–54.9%", "5 Star": "55.0–69.9%", PRIME: "70.0–100%" };
export const GOLD = "#C9A227";
export const NAVY = "#013A5A";

export const fmtPct = (v) => (v === null || v === undefined ? null : `${Number(v).toFixed(2)}%`);
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString() : "");
export const roleLabel = (r) => ({ owner: "Agency owner", producer: "Producer", staff: "Agency staff" }[r] || r);
export const FLAG_TEXT = {
  level_mismatch: "Published level differs from the band for this score — both kept as reported",
  borderline: "Score is within 0.05 of a band edge; source rounding could change the level",
};
